/** Shared layout tokens for proposal cover + sticky logo. */

/** Sticky tab nav sits below the fixed Clarity logo when cover fills the viewport. */
export const PROPOSAL_STICKY_TAB_TOP_CLASS = "top-14 sm:top-16";

/** Reserve right edge so horizontal tabs do not slide under the fixed logo. */
export const PROPOSAL_TAB_NAV_LOGO_PADDING_CLASS = "pr-[calc(6.5rem+1.5rem)] sm:pr-[calc(8vw+12rem)]";

/** Full-viewport cover height — max(svh, dvh) avoids mobile browser chrome peek. */
export const PROPOSAL_COVER_FULL_VIEWPORT_CLASS = "min-h-[max(100svh,100dvh)]";
